export const myPageRoutePaths = {
  main: {
    path: 'my-page',
    fullPath: '/my-page',
  },
  voteHistory: {
    path: 'vote-history',
    fullPath: '/my-page/vote-history',
  },
  notifications: {
    path: 'notifications',
    fullPath: '/my-page/notifications',
  },
  // TRAD-1964 — /my-page/notifications는 기존 알림 인박스(Notifications.tsx)가 점유 중이라
  // 설정화면은 그 하위 서브라우트로 신설(팀장 확정, 인박스/벨 아이콘 무변경).
  notificationSettings: {
    path: 'notifications/settings',
    fullPath: '/my-page/notifications/settings',
  },
  settings: {
    path: 'settings',
    fullPath: '/my-page/settings',
  },
  point: {
    path: 'point',
    fullPath: '/my-page/point',
  },
};
